import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import PublicLayoutContainer from './containers/PublicLayoutContainer';
import AuthLayoutContainer from './containers/AuthLayoutContainer';
import DashboardLayoutContainer from './containers/DashboardLayoutContainer';
import ProfileContainer from './containers/ProfileContainer';
import LoginContainer from './containers/LoginContainer';
import SignUp from './components/pages/login/SignUp';
import PublicHome from './components/public/home';
import OpenHome from './components/public/open';
import AuthHome from './components/auth/home';
import NoMatch from './components/notFound';
import Dashboard from './components/dashboard/index';
import Profile from './components/profile/home';
import ProcessPayment from './components/pages/process-payment';
import AOS from 'aos';
import ForgotPasswordContainer from './containers/ForgotPasswordContainer';
import SetPasswordContainer from './containers/SetPasswordContainer';
import UaePassCallBack from './components/pages/login/UaePassCallBack';
import ReactivateUserContainer from './containers/ReactivateUserContainer';
import Fallback from './components/public/fallback';

const RouteWithLayout = ({ layout: Layout, component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        React.createElement(
          Layout,
          props,
          React.createElement(Component, props)
        )
      }
    />
  );
};

class App extends Component {
  componentDidMount() {
    AOS.init();

    let user = window.user ? window.user : localStorage.getItem('user') || null;
    user = typeof user === 'string' ? JSON.parse(user) : user;

    const pathname = window.location && window.location.pathname;

    // should not match domains like https://app.bemycred...
    const hasAppPath =
      window.location.href.includes('/app') &&
      !window.location.href.includes('://app');

    const isRootUrl =
      window.location.href ===
      `${window.location.protocol}//${window.location.hostname}/`;

    const isAllowedPublicPath =
      window.location.href.includes('/app/setpassword') ||
      window.location.href.includes('/app/forgotpassword') ||
      window.location.href.includes('/public/link');

    if (pathname === '/' && !(user && user.email)) {
      window.location.href = '/login';
      return;
    }

    if (pathname === '/' && user && user.email) {
      window.location.href = '/app';
      return;
    }

    if (!hasAppPath && isRootUrl && user && user.email) {
      window.location.href = '/app';
      return;
    }

    if (hasAppPath && !isAllowedPublicPath && !(user && user.email)) {
      window.location.href = '/login';
      return;
    }

    if (pathname === '/login' && user && user.email && !window.location.href.includes('://app')) {
      window.location.href = '/app';
      return;
    }
  }

  render() {
    let totalQuantityAdded = 0;
    const globalOrderItems = localStorage.getItem('orderitems');
    if (globalOrderItems) {
      const parsedData = JSON.parse(globalOrderItems);
      totalQuantityAdded = parsedData ? parsedData.length : 0;
    }

    return (
      <div className="neene-player-app h-100">
        <Switch>
          <RouteWithLayout
            layout={PublicLayoutContainer}
            exact
            path="/login"
            component={PublicHome}
          />

          <RouteWithLayout
            layout={PublicLayoutContainer}
            path="/open"
            component={OpenHome}
          />

          <RouteWithLayout
            layout={PublicLayoutContainer}
            exact
            path="/public/link/:linkId"
            component={PublicHome}
          />

          <RouteWithLayout
            layout={PublicLayoutContainer}
            exact
            path="/fallback"
            component={Fallback}
          />

          <Route path="/processpayment" component={ProcessPayment} />
          <Route path="/welcome" component={LoginContainer} />
          <Route path="/app/signup" component={SignUp} />
          <Route path="/app/forgotpassword" component={ForgotPasswordContainer} />
          <Route path="/app/setpassword/:reflink" component={SetPasswordContainer} />
          <Route path="/processgateway" component={UaePassCallBack} />
          <Route path="/app/reactivateUser" component={ReactivateUserContainer} />
          
          <Switch>
            <RouteWithLayout
              layout={AuthLayoutContainer}
              path="/app"
              component={AuthHome}
            />

            <RouteWithLayout
              layout={DashboardLayoutContainer}
              path="/dashboard"
              component={Dashboard}
            />

            <RouteWithLayout
              layout={ProfileContainer}
              path="/profile"
              component={Profile}
            />

            <Route
              exact
              path="/"
              render={() => {
                let user = window.user ? window.user : localStorage.getItem('user') || null;
                user = typeof user === 'string' ? JSON.parse(user) : user;
                return user && user.email ? <Redirect to="/app" /> : <Redirect to="/login" />;
              }}
            />

            <Route path="*" component={NoMatch} />
          </Switch>
        </Switch>
      </div>
    );
  }
}

export default App;